import { Route } from "react-router";
import { ROUTES, FLAGS } from "../constants";
import {
  Applications,
  Settings,
  AppDataModal,
  ApplicationDeploymentsTrack,
} from "../pages/Applications";
import {
  ApiDocs,
  BackgroundTasks,
  Collections,
  Collection,
  DataModelData,
  DataModels,
  DataModelSettings,
  TableData,
  Service,
  Endpoints,
  Services,
  Secrets,
  DataModelDeploymentsTrack,
} from "../pages/DataModels";
import { UserRoles, Users, Invitations } from "../pages/Users";
import { AmplifyAuth } from "../infrastructure/Authentication";
import {
  GenerateFromMulesoft,
  MulesoftEndpoints,
  MulesoftServices,
  MulesoftApiDocs,
  MuleIntegrations,
} from "../pages/Mulesoft";
import Organizations from "../pages/Organizations/Organizations";
import OrganizationUsers from "../pages/Organizations/organizationUsers";
import UserProfile from "../pages/UserProfile/UserProfile";
import DevConsole from "../pages/DevConsole/DevConsole";
import QueryTool from "../pages/DataModels/QueryTool";

const {
  APP_SETTINGS,
  APP_DATA_MODAL,
  APPLICATIONS,
  DATAMODELS,
  DATA_MODEL_COLLECTIONS,
  DATA_MODEL_ENDPOINTS,
  DATA_MODEL_SERVICES,
  DATA_MODEL_SERVICE,
  DATA_MODEL_DATA,
  DATA_MODEL_SETTINGS,
  DATA_MODEL_TABLE_DATA,
  BACKGROUND_TASKS,
  COLLECTION_DETAILS,
  USERS,
  INVITATIONS,
  USERROLES,
  API_DOCS,
  MULESOFT_ENDPOINTS,
  MULESOFT_SERVICES,
  MULESOFT,
  MULESOFT_API_DOCS,
  MULESOFT_SERVICE,
  MULESOFT_GENERATE,
  ORGANIZATIONS,
  ORGANIZATION_USERS,
  DATA_MODEL_SECRETS,
  USER_PROFILE,
  APPLICATION_DEPLOYMENTS_TRACK,
  DATAMODEL_DEPLOYMENTS_TRACK,
  DEVELOPER_CONSOLE,
  QUERY_TOOL,
} = ROUTES;

const {
  SHOW_APPLICATIONS,
  SHOW_DATA_MODELS,
  SHOW_USERS,
  SHOW_APPLICATION_SETTINGS,
  SHOW_COLLECTIONS,
  SHOW_ENDPOINTS,
  SHOW_SERVICES,
  SHOW_BACKGROUND_TASKS,
  SHOW_API_DOCS,
  SHOW_DATA_MODEL_SETTINGS,
  SHOW_DATA,
  SHOW_INTEGRATIONS,
  SHOW_USER_ROLES,
  SHOW_INVITATIONS,
  SHOW_MULESOFT_GENERATED_ENDPOINTS,
  SHOW_ORGANIZATIONS,
  SHOW_APP_DATA_MODAL,
  SHOW_USER_PROFILE,
  SHOW_APPLICATION_DEPLOYMENTS_TRACK,
  SHOW_DATA_MODEL_DEPLOYMENTS_TRACK,
  SHOW_DEVELOPER_CONSOLE,
  SHOW_QUERY_TOOL,
} = FLAGS;

const getRoute = (feature, shouldShowNavAndSidePanel) => {
  switch (feature) {
    case SHOW_APPLICATIONS:
      return (
        <Route
          exact
          path={APPLICATIONS}
          element={
            <AmplifyAuth>
              <Applications />
            </AmplifyAuth>
          }
        />
      );
    case SHOW_DATA_MODELS:
      return (
        <Route
          exact
          path={DATAMODELS}
          element={
            <AmplifyAuth>
              <DataModels />
            </AmplifyAuth>
          }
        />
      );
    case SHOW_USERS:
      return (
        <Route
          exact
          path={USERS}
          element={
            <AmplifyAuth>
              <Users />
            </AmplifyAuth>
          }
        />
      );

    case SHOW_APPLICATION_SETTINGS:
      return (
        <Route
          exact
          path={APP_SETTINGS}
          element={
            <AmplifyAuth>
              <Settings />
            </AmplifyAuth>
          }
        />
      );

    case SHOW_COLLECTIONS:
      return (
        <>
          <Route
            exact
            path={DATA_MODEL_COLLECTIONS}
            element={
              <AmplifyAuth>
                <Collections />
              </AmplifyAuth>
            }
          />
          <Route
            exact
            path={COLLECTION_DETAILS}
            element={
              <AmplifyAuth>
                <Collection />
              </AmplifyAuth>
            }
          />
        </>
      );
    case SHOW_ENDPOINTS:
      return (
        <Route
          exact
          path={DATA_MODEL_ENDPOINTS}
          element={
            <AmplifyAuth>
              <Endpoints />
            </AmplifyAuth>
          }
        />
      );
    case SHOW_SERVICES:
      return (
        <>
          <Route
            exact
            path={DATA_MODEL_SERVICES}
            element={
              <AmplifyAuth>
                <Services />
              </AmplifyAuth>
            }
          />
          <Route
            exact
            path={DATA_MODEL_SERVICE}
            element={
              <AmplifyAuth>
                <Service />
              </AmplifyAuth>
            }
          />
        </>
      );
    case SHOW_BACKGROUND_TASKS:
      return (
        <Route
          exact
          path={BACKGROUND_TASKS}
          element={
            <AmplifyAuth>
              <BackgroundTasks />
            </AmplifyAuth>
          }
        />
      );
    case SHOW_API_DOCS:
      return (
        <Route
          exact
          path={API_DOCS}
          element={
            <AmplifyAuth>
              <ApiDocs />
            </AmplifyAuth>
          }
        />
      );
    case SHOW_DATA:
      return (
        <>
          <Route
            exact
            path={DATA_MODEL_DATA}
            element={
              <AmplifyAuth>
                <DataModelData />
              </AmplifyAuth>
            }
          />
          <Route
            exact
            path={DATA_MODEL_TABLE_DATA}
            element={
              <AmplifyAuth>
                <TableData />
              </AmplifyAuth>
            }
          />
        </>
      );
    case SHOW_DATA_MODEL_SETTINGS:
      return (
        <>
          <Route
            exact
            path={DATA_MODEL_SETTINGS}
            element={
              <AmplifyAuth>
                <DataModelSettings />
              </AmplifyAuth>
            }
          />
          <Route
            exact
            path={DATA_MODEL_SECRETS}
            element={
              <AmplifyAuth>
                <Secrets />
              </AmplifyAuth>
            }
          />
        </>
      );
    case SHOW_USER_ROLES:
      return (
        <Route
          exact
          path={USERROLES}
          element={
            <AmplifyAuth>
              <UserRoles />
            </AmplifyAuth>
          }
        />
      );
    case SHOW_INVITATIONS:
      return (
        <Route
          exact
          path={INVITATIONS}
          element={
            <AmplifyAuth>
              <Invitations />
            </AmplifyAuth>
          }
        />
      );
    case SHOW_USER_PROFILE:
      return (
        <Route
          exact
          path={USER_PROFILE}
          element={
            <AmplifyAuth>
              <UserProfile />
            </AmplifyAuth>
          }
        />
      );
    case SHOW_INTEGRATIONS:
      return (
        <Route
          exact
          path={MULESOFT}
          element={
            <AmplifyAuth>
              <MuleIntegrations />
            </AmplifyAuth>
          }
        />
      );

      case SHOW_QUERY_TOOL:
      return (
        <Route
          exact
          path={QUERY_TOOL}
          element={
            <AmplifyAuth>
              <QueryTool />
            </AmplifyAuth>
          }
        />
      );
    case SHOW_MULESOFT_GENERATED_ENDPOINTS: {
      return (
        <>
          <Route
            exact
            path={MULESOFT_ENDPOINTS}
            element={
              <AmplifyAuth>
                <MulesoftEndpoints />
              </AmplifyAuth>
            }
          />
          <Route
            exact
            path={MULESOFT_SERVICES}
            element={
              <AmplifyAuth>
                <MulesoftServices />
              </AmplifyAuth>
            }
          />
          <Route
            exact
            path={MULESOFT_SERVICE}
            element={
              <AmplifyAuth>
                <Service />
              </AmplifyAuth>
            }
          />
          <Route
            exact
            path={MULESOFT_API_DOCS}
            element={
              <AmplifyAuth>
                <MulesoftApiDocs />
              </AmplifyAuth>
            }
          />
          <Route
            exact
            path={MULESOFT_GENERATE}
            element={
              <AmplifyAuth>
                <GenerateFromMulesoft />
              </AmplifyAuth>
            }
          />
        </>
      );
    }
    case SHOW_ORGANIZATIONS: {
      return (
        <>
          <Route
            exact
            path={ORGANIZATIONS}
            element={
              <AmplifyAuth>
                <Organizations />
              </AmplifyAuth>
            }
          />
          <Route
            exact
            path={ORGANIZATION_USERS}
            element={
              <AmplifyAuth>
                <OrganizationUsers />
              </AmplifyAuth>
            }
          />
        </>
      );
    }
    case SHOW_APP_DATA_MODAL: {
      return (
        <Route
          exact
          path={APP_DATA_MODAL}
          element={
            <AmplifyAuth>
              <AppDataModal />
            </AmplifyAuth>
          }
        />
      );
    }
    case SHOW_APPLICATION_DEPLOYMENTS_TRACK:
      return (
        <Route
          exact
          path={APPLICATION_DEPLOYMENTS_TRACK}
          element={
            <AmplifyAuth>
              <ApplicationDeploymentsTrack />
            </AmplifyAuth>
          }
        />
      );
    case SHOW_DATA_MODEL_DEPLOYMENTS_TRACK:
      return (
        <Route
          exact
          path={DATAMODEL_DEPLOYMENTS_TRACK}
          element={
            <AmplifyAuth>
              <DataModelDeploymentsTrack />
            </AmplifyAuth>
          }
        />
      );
    case SHOW_DEVELOPER_CONSOLE:
      return (
        <Route
          exact
          path={DEVELOPER_CONSOLE}
          element={
            <AmplifyAuth>
              <DevConsole />
            </AmplifyAuth>
          }
        />
      );
    default:
      break;
  }
};

export default getRoute;
